module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/header-image-05-76fb5f27e16efb2592a50e9f764d3201.jpg";